import useApiRequest from "@/lib/hooks/use-request";
import { CalculationNumberResponseDto, UpdateCalculationNumberRequestDto } from "@/lib/interfaces/numbers";
import { Button } from "@/ui-components/ui/button";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/ui-components/ui/form";
import { Input } from "@/ui-components/ui/input";
import { zodResolver } from "@hookform/resolvers/zod";
import { Dispatch, SetStateAction } from "react";
import { useForm } from "react-hook-form";
import * as z from "zod";

const formSchema = z.object({
  costPerLead: z.number().min(0),
  ownLeadProfit: z.number().min(0),
  accesoriesProvision: z.number().min(0),
});

const NumbersEditor = ({
  item,
  setReload,
}: {
  item: CalculationNumberResponseDto;
  setReload: Dispatch<SetStateAction<boolean>>;
}) => {
  const { apiRequest } = useApiRequest();

  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      costPerLead: item.costPerLead,
      ownLeadProfit: item.ownLeadProfit,
      accesoriesProvision: item.accesoriesProvision,
    },
  });

  const onSubmit = async (values: z.infer<typeof formSchema>) => {
    const req: UpdateCalculationNumberRequestDto = {
      costPerLead: values.costPerLead,
      ownLeadProfit: values.ownLeadProfit,
      accesoriesProvision: values.accesoriesProvision,
    };

    const response = await apiRequest<CalculationNumberResponseDto>("settings/calculation-numbers", "PATCH", {
      body: req,
      toast: {
        toastText: "Zahlen erfolgreich gespeichert",
      },
    });

    if (response.data) {
      setReload((prev) => !prev);
    }
  };

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
        <FormField
          control={form.control}
          name="costPerLead"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="text-[16px] font-bold">Kosten pro Lead:*</FormLabel>
              <FormControl>
                <Input type="number" {...field} onChange={(e) => field.onChange(parseFloat(e.target.value))} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="ownLeadProfit"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="text-[16px] font-bold">Eigener Lead Profit:*</FormLabel>
              <FormControl>
                <Input type="number" {...field} onChange={(e) => field.onChange(parseFloat(e.target.value))} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="accesoriesProvision"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="text-[16px] font-bold">Zubehör Provision:*</FormLabel>
              <FormControl>
                <Input type="number" {...field} onChange={(e) => field.onChange(parseFloat(e.target.value))} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <Button type="submit">Speichern</Button>
      </form>
    </Form>
  );
};

export default NumbersEditor;
